const bulk = components => components.map(component => ({
  handler: component.handler,
  linkId: component.linkId,
  order: component.order,
  data: {
    meta: component.linkMeta,
    options: component.linkOptions
  }
}));
export { bulk };